import ReactDOM from "react-dom/client";
import { RecoilRoot } from "recoil";

import { ScreenProvider } from "@lib/contexts/ScreenProvider.tsx";

import "./i18n.ts";

import App from "./App.tsx";

import "./styles/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <RecoilRoot>
    <ScreenProvider>
      <App />
    </ScreenProvider>
  </RecoilRoot>,
  // </React.StrictMode>,
);
